import { CancelIconButton, DeleteIconButton, Grid } from "@compass/core";
import { FilePanel, InlineEditDataModel } from "components";
import { NonPersonnelFile as NonPersonnelFileModel, Permission, PermissionAction, UploadFile } from "generated/openApi";
import { useInlineEditDataModel } from "hooks";
import produce from "immer";
import "moment-timezone";
import { isAuthorized } from "services";
import { initDataModel } from "utils";

export const NonPersonnelFile = (props: {
  rootPermission: Permission;
  nonPersonnelFile: NonPersonnelFileModel;
  setNonPersonnelFile: (nonPersonnelFile: NonPersonnelFileModel) => void;
  cancelCreate: () => void;
}) => {
  const { removing, canCancel, canRemove, cancel, remove } = useInlineEditDataModel({
    dataModel: props.nonPersonnelFile,
    setDataModel: props.setNonPersonnelFile,
    cancelCreate: props.cancelCreate,
  });

  return (
    <InlineEditDataModel
      noPadding
      overflow="auto"
      actions={
        <>
          {isAuthorized(props.rootPermission, PermissionAction.Delete) && canRemove && (
            <DeleteIconButton onClick={remove} size="small" />
          )}
          {canCancel && <CancelIconButton onClick={cancel} size="small" />}
        </>
      }
      content={
        <FilePanel
          border={false}
          fileName={props.nonPersonnelFile.uploadFile.fileName}
          fileRef={props.nonPersonnelFile.uploadFile.fileRef}
          fileSize={props.nonPersonnelFile.uploadFile.fileSize}
          uploadingData={props.nonPersonnelFile.uploadFile?.uploadingData}
          imagePreviewData={props.nonPersonnelFile.uploadFile?.imagePreviewData}
          onFileChange={(fileName, fileSize, uploadingData) => {
            props.setNonPersonnelFile(
              produce(props.nonPersonnelFile, (draft) => {
                draft.uploadFile = initDataModel<UploadFile>({
                  fileName: fileName,
                  fileSize: fileSize,
                  uploadingData: uploadingData,
                });
              })
            );
          }}
        />
      }
      removing={removing}
    />
  );
};
